export default "/fonts/vendor/tinymce/skins/lightgray/tinymce-small.ttf?afc8a0139a615b13b36309da1c5c03d0";